module.exports = __webpack_public_path__ + "img/02-dark.ab70bafe.png";